import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr";

import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext";
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang";
import moment from "moment";
import MyEditor from "components/MyEditor";
import UploadFileS3 from "components/UploadFileS3";
import InputAttachment from "components/Input/attachment/InputAttachment";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import UploadDesc from "components/UploadDesc";
import { ReactSortable } from 'react-sortablejs';
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner";
import { slugify } from "helpers/fn_helper";

// Services
import { SearchPageSetting, SavePageSetting, UpdatePageSetting } from "../../services/api/module/PageSetting.js"
import { UpdateContent, CreateContent, GetContentById } from "./services/Services";
import CardDetail from "./_components/CardDetail";
import InputText from "components/Input/InputText";
import Error401 from "components/Error401";

const STATUS_OPTION = fn_helper.OPTIONS.STATUS

const _routeLink = `sustainability-performance`
const _pageName = `Sustainability Performance Content Setting`
const _routePermission = `sustainability-performance:content-setting`

const DEF_SORT = [1, 2, 3, 4, 5]
const DEF_SORT1 = [1, 2, 3, 4, 5, 6, 7]
const DEF_SORT2 = [1, 2, 3, 4, 5]
const DEF_SORT3 = [1, 2, 3, 4, 5, 6, 7, 8, 9]

const MaxContent1 = 7
const MaxContent2 = 5;
const MaxContent3 = 9;

const SustainabilityPerformanceContentTemplate = ({
    pageView = "create",
    componentKey = "",
}) => {
    // POPUP
    const { mAlert } = useContext(ModalContext);

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? 'TH'
    const qMainId = 1
    const navigate = useNavigate();

    const [waitSendData, setWaitSendData] = useState(false)
    const [contentLoading, setContentLoading] = useState(false)

    const [contentCard1Show, setcontentCard1Show] = useState(false)
    const [contentCard2Show, setcontentCard2Show] = useState(false)
    const [contentCard3Show, setcontentCard3Show] = useState(false)
    const [contentCard4Show, setcontentCard4Show] = useState(false)
    const [contentCard5Show, setcontentCard5Show] = useState(false)

    // const [content1Card1Show, setContent1Card1Show] = useState(false);
    // const [content1Card2Show, setContent1Card2Show] = useState(false);
    // const [content1Card3Show, setContent1Card3Show] = useState(false);
    // const [content1Card4Show, setContent1Card4Show] = useState(false);
    // const [content1Card5Show, setContent1Card5Show] = useState(false);
    // const [content1Card6Show, setContentCard6Show] = useState(false);
    // const [content1Card7Show, setContent1Card7Show] = useState(false);

    // const [content2Card1Show, setContent2Card1Show] = useState(false);
    // const [content2Card2Show, setContent2Card2Show] = useState(false);
    // const [content2Card3Show, setContent2Card3Show] = useState(false);
    // const [content2Card4Show, setContent2Card4Show] = useState(false);
    // const [content2Card5Show, setContent2Card5Show] = useState(false);

    // const [content3Card1Show, setContent3Card1Show] = useState(false);
    // const [content3Card2Show, setContent3Card2Show] = useState(false);
    // const [content3Card3Show, setContent3Card3Show] = useState(false);
    // const [content3Card4Show, setContent3Card4Show] = useState(false);
    // const [content3Card5Show, setContent3Card5Show] = useState(false);
    // const [content3Card6Show, setContent3Card6Show] = useState(false);
    // const [content3Card7Show, setContent3Card7Show] = useState(false);
    // const [content3Card8Show, setContent3Card8Show] = useState(false);
    // const [content3Card9Show, setContent3Card9Show] = useState(false);


    const [contentCards, setContentCards] = useState({
        content1Card1Show: false,
        content1Card2Show: false,
        content1Card3Show: false,
        content1Card4Show: false,
        content1Card5Show: false,
        content1Card6Show: false,
        content1Card7Show: false,
        content2Card1Show: false,
        content2Card2Show: false,
        content2Card3Show: false,
        content2Card4Show: false,
        content2Card5Show: false,
        content3Card1Show: false,
        content3Card2Show: false,
        content3Card3Show: false,
        content3Card4Show: false,
        content3Card5Show: false,
        content3Card6Show: false,
        content3Card7Show: false,
        content3Card8Show: false,
        content3Card9Show: false,
    });

    // Function to update state dynamically
    const setContentState = (key, value) => {
        setContentCards(prevState => ({
            ...prevState,
            [key]: value
        }));
    };
    const handleCheckboxChange = (key) => {
        setContentCards((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };


    const [cardSeq, setCardSeq] = useState(DEF_SORT)
    const [cardSeq1, setCardSeq1] = useState(DEF_SORT1)
    const [cardSeq2, setCardSeq2] = useState(DEF_SORT2)
    const [cardSeq3, setCardSeq3] = useState(DEF_SORT3)

    // ========== Form Validation ========== //
    const validationSchema = Yup.object({
        // contentPageName: Yup.string().required("Please Enter Site Name"),
        // slug: Yup.string().max(255).required("Please Enter Slug"),

        contentDetail: Yup.string().max(255),

        // contentCard1Detail: Yup.string().max(255),
        // contentCard1Number: Yup.string().max(100),
        // contentCard1Unit: Yup.string().max(100),


        // contentSeoTitle: Yup.string(),
        // contentSeoKeyword: Yup.string().max(1024),
        // contentSeoDescription: Yup.string().max(1024),

        contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
        contentStatus: Yup.string().max(100).required("Please Enter Display"),
        contentDetail: Yup.string().required("Please Enter Please Enter Business deatil"),

    })


    // LOCAL STATE FORM
    const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

    const initialValues = {
        contentId: "",

        // Content
        // contentSitename: "",
        // slug: "",
        contentDetail: "",
        bannerDesktop: {},
        bannerMobile: {},

        contentSeoTitle: "",
        contentSeoKeyword: "",
        contentSeoDescription: "",
        contentUpdateDate: moment().format('YYYY-MM-DD'),
        contentStatus: "active",

        slug: "",
        contentPageName: "",
    }

    const fnSortCardSeq = (seqNoSort = [], valueList = []) => {
        let newValueList = []
        for (let no of seqNoSort) {
            console.log('no', no)
            const valueWithNo = valueList.find((item, i) => (i + 1) == no)
            newValueList.push(valueWithNo)
        }

        return newValueList
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: updatedValidationSchema,
        onSubmit: values => {
            console.log("🚀 ~ ExecutivesPageCreate ~ values:", values)
            // Create the array dynamically from values and handle more content cards
            const valueSort1 = fnSortCardSeq(
                cardSeq1,
                Array.from({ length: MaxContent1 }, (_, i) => ({
                    contentCardShow: values[`content1Card${i + 1}Show`],
                    contentCardDetail: values[`content1Card${i + 1}Detail`],
                    cardImage: values[`content1Card${i + 1}Image`],
                }))
            );
            const valueSort2 = fnSortCardSeq(
                cardSeq2,
                Array.from({ length: MaxContent2 }, (_, i) => ({
                    contentCardShow: values[`content2Card${i + 1}Show`],
                    contentCardDetail: values[`content2Card${i + 1}Detail`],
                    cardImage: values[`content2Card${i + 1}Image`],
                }))
            );
            const valueSort3 = fnSortCardSeq(
                cardSeq3,
                Array.from({ length: MaxContent3 }, (_, i) => ({
                    contentCardShow: values[`content3Card${i + 1}Show`],
                    contentCardDetail: values[`content3Card${i + 1}Detail`], // Fixed typo
                    cardImage: values[`content3Card${i + 1}Image`],
                }))
            );

            const payload = {
                id: qMainId,
                contentId: values.contentId ? values.contentId : undefined,
                langId: qLang,
                contentDetail: values.contentDetail,

                // Populate contentCardShow and contentCardDetail fields for all valueSorts
                ...Object.fromEntries(
                    valueSort1.map((item, index) => [
                        `content1Card${index + 1}Show`,
                        item.contentCardShow,
                    ])
                ),
                ...Object.fromEntries(
                    valueSort1.map((item, index) => [
                        `content1Card${index + 1}Detail`,
                        item.contentCardDetail,
                    ])
                ),
                ...Object.fromEntries(
                    valueSort2.map((item, index) => [
                        `content2Card${index + 1}Show`,
                        item.contentCardShow,
                    ])
                ),
                ...Object.fromEntries(
                    valueSort2.map((item, index) => [
                        `content2Card${index + 1}Detail`,
                        item.contentCardDetail,
                    ])
                ),
                ...Object.fromEntries(
                    valueSort3.map((item, index) => [
                        `content3Card${index + 1}Show`,
                        item.contentCardShow,
                    ])
                ),
                ...Object.fromEntries(
                    valueSort3.map((item, index) => [
                        `content3Card${index + 1}Detail`,
                        item.contentCardDetail,
                    ])
                ),

                contentUpdateDate: values.contentUpdateDate,
                contentStatus: values.contentStatus,

                // Combine attachmentData for all valueSorts
                attachmentData: {
                    
                },

                contentAttachmentData: {
                    ...Object.fromEntries(
                        valueSort1.map((item, index) => [
                            `content1Card${index + 1}Image`,
                            item.cardImage ? item.cardImage : undefined,
                        ])
                    ),
                    ...Object.fromEntries(
                        valueSort2.map((item, index) => [
                            `content2Card${index + 1}Image`,
                            item.cardImage ? item.cardImage : undefined,
                        ])
                    ),
                    ...Object.fromEntries(
                        valueSort3.map((item, index) => [
                            `content3Card${index + 1}Image`,
                            item.cardImage ? item.cardImage : undefined,
                        ])
                    ),
                },
            };

            console.log("Payload:", payload);


            const pageSettingRoute = {
                contentPageName: values.contentPageName,
                slug: values.slug.replace(/-+$/, ''),
                componentKey: componentKey,
                contentDetail: values.contentDetail,
                attachmentData: {
                    bannerDesktop: values.bannerDesktop,
                    bannerMobile: values.bannerMobile,
                },
                contentAttachmentData: {

                },
                contentSeoTitle: values.contentSeoTitle,
                contentSeoKeyword: values.contentSeoKeyword,
                contentSeoDescription: values.contentSeoDescription,
                contentUpdateDate: values.contentUpdateDate,
                contentStatus: values.contentStatus,
            };

            console.log("🚀 ~ onSave ~ pageSettingRoute:", pageSettingRoute);

            setWaitSendData(true)

            if (pageView === "update") {
                API.fetchUpdateContentPageSetting(payload, pageSettingRoute)
            } else {
                API.fetchCreateContent(payload, pageSettingRoute)
            }
        },
    })


    const preFilInputPage = (resData = {}) => {
        console.log("🚀 ~ preFilInputPage ~ resData:", resData)

    }
    // Helper function to update content state and validation fields
    const updateContentFields = (prefix, maxCount, resData, validation) => {
        let updatedContentCards = {};

        for (let i = 1; i <= maxCount; i++) {
            const showKey = `${prefix}Card${i}Show`;
            const detailKey = `${prefix}Card${i}Detail`;
            const imgKey = `${prefix}Card${i}Image`;

            // Batch state update preparation
            updatedContentCards[showKey] = resData?.[showKey] ?? false;

            // Set validation fields
            validation.setFieldValue(showKey, resData?.[showKey] ?? "");
            validation.setFieldValue(detailKey, resData?.[detailKey] ?? "");
            validation.setFieldValue(imgKey, resData?.contentAttachmentList?.find((obj) => obj.attachmentField == `${prefix}_card${i}_image` ?? ""));
        }

        // Update state with batched content cards
        setContentCards(prevState => ({
            ...prevState,
            ...updatedContentCards
        }));
    };

    const preFilInput = (resData = {}) => {
        console.log("🚀 ~ preFilInput ~ resData:", resData)
        // resetForm(validation.values, initialValues)

        // ถ้าไม่หน่วงมันจะแย่งกันทำ
        // validation.setFieldValue("contentId", resData?.contentId ?? "")
        // validation.setFieldValue("contentSitename", resData?.contentSitename ?? "")
        // validation.setFieldValue("slug", resData?.slug ?? "")
        // validation.setFieldValue("contentHeadline", resData?.contentHeadline ?? "")
        validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")

        setcontentCard1Show(resData?.contentCard1Show ?? false)
        validation.setFieldValue("contentCard1Show", resData?.contentCard1Show ?? "")
        validation.setFieldValue("contentCard1Detail", resData?.contentCard1Detail ?? "")

        // Usage of the helper function for different content types
        updateContentFields('content1', MaxContent1, resData, validation);
        updateContentFields('content2', MaxContent2, resData, validation);
        updateContentFields('content3', MaxContent3, resData, validation);


        // console.log('resData.attachmentList.find(obj => obj.attachmentField == "banner_desktop"', resData.attachmentList.find(obj => obj.attachmentField == "banner_desktop"))

        validation.setFieldValue("detail_image1", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'detail_image1') ?? "")
        validation.setFieldValue("detail_image2", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'detail_image2') ?? "")
        validation.setFieldValue("detail_image3", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'detail_image3') ?? "")

        validation.setFieldValue(
            "organizationChartDesktop",
            resData?.contentAttachmentList
                ?.find(
                    obj => obj.attachmentField == "organization_chart_desktop"
                ) ?? ""
        )
        validation.setFieldValue(
            "organizationChartMobile",
            resData?.contentAttachmentList?.find(
                obj => obj.attachmentField == "organization_chart_mobile"
            ) ?? ""
        )

        validation.setFieldValue(
            "contentUpdateDate",
            resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
        )
        validation.setFieldValue(
            "contentStatus",
            resData?.contentStatus ?? "active"
        )

        // validation.setFieldValue("contentPageName", resData?.pageSettingRoute?.contentPageName ?? "")
        // validation.setFieldValue("slug", resData?.pageSettingRoute?.slug ?? "")
    }
    useEffect(() => {

        // Render checkboxes for content1Card1Show to content1Card7Show
        {
            Array.from({ length: MaxContent1 }, (_, i) => (
                <input
                    type="checkbox"
                    id={`content1Card${i + 1}Show`}
                    checked={contentCards[`content1Card${i + 1}Show`] || false}
                    onChange={() => handleCheckboxChange(`content1Card${i + 1}Show`)}
                    key={`content1Card${i + 1}Show`}
                />
            ))
        }

        // Render checkboxes for content2Card1Show to content2Card5Show
        {
            Array.from({ length: MaxContent2 }, (_, i) => (
                <input
                    type="checkbox"
                    id={`content2Card${i + 1}Show`}
                    checked={contentCards[`content2Card${i + 1}Show`] || false}
                    onChange={() => handleCheckboxChange(`content2Card${i + 1}Show`)}
                    key={`content2Card${i + 1}Show`}
                />
            ))
        }

        // Render checkboxes for content3Card1Show to content3Card9Show
        {
            Array.from({ length: MaxContent3 }, (_, i) => (
                <input
                    type="checkbox"
                    id={`content3Card${i + 1}Show`}
                    checked={contentCards[`content3Card${i + 1}Show`] || false}
                    onChange={() => handleCheckboxChange(`content3Card${i + 1}Show`)}
                    key={`content3Card${i + 1}Show`}
                />
            ))
        }
    }, [contentCards]);


    const API = {
        fetchGetContentPageSetting: async componentKey => {
            try {
                const response = await SearchPageSetting(componentKey, {
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 200) {
                    preFilInputPage(resData.data)
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong 001",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setContentLoading(false)
            }
        },

        fetchGetContentById: async payload => {
            try {
                const response = await GetContentById({
                    id: payload.id,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 200) {
                    preFilInput(resData.data)
                }
            } catch (err) {
                console.log("err ", err)
                qMainId = 0;
                // mAlert.info({
                //     title: "Alert",
                //     subTitle: "Something went wrong 001",
                //     content: "",
                //     onClose: () => {
                //         //  alert("onClose")
                //     },
                // })
            } finally {
                setContentLoading(false)
            }
        },
        fetchCreateContent: async (payload, pageSettingRoute) => {
            try {
                const response = await CreateContent({ data: payload, lang: qLang })
                const resData = response.data
                if (resData.status == 201) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Created Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/${_routeLink}/${qLang}/edit`)
                            window.location.reload()
                        },
                    })
                }
            } catch (e) {
                console.log(e)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
        fetchUpdateContentPageSetting: async (payload, pageSettingRoute) => {
            try {
                // const responseP = await UpdatePageSetting(componentKey, { data: pageSettingRoute, lang: qLang })
                const response = await UpdateContent({ data: payload, id: payload.id, lang: qLang })
                const resData = response.data
                if (resData.error && resData.status == 406) {
                    response = await CreateContent({ data: payload, lang: qLang })
                    resData = response.data
                    if (resData.status == 201) {
                        mAlert.info({
                            title: "Alert",
                            subTitle: "Update Data Success",
                            content: "",
                            onClose: () => {
                                // navigate(`/${_routeLink}/page/${qLang}/edit`)
                                window.location.reload()
                            },
                        })
                    }
                } else if (resData.status == 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/${_routeLink}/page/${qLang}/edit`)
                            window.location.reload()
                        },
                    })
                }
            }
            catch (err) {
                console.log('err ', err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        }
    }

    // กรณี Edit
    useEffect(() => {
        if (["update", "view"].includes(pageView)) {
            const payload = { id: qMainId }
            setContentLoading(true)

            API.fetchGetContentById(payload)
            // API.fetchGetContentPageSetting(componentKey)
        }
    }, [qLang])



    // useEffect(() => {
    // document.getElementById(`contentCard1Show`).checked = contentCard1Show
    // document.getElementById(`contentCard2Show`).checked = contentCard2Show
    // document.getElementById(`contentCard3Show`).checked = contentCard3Show
    // document.getElementById(`contentCard4Show`).checked = contentCard4Show
    // document.getElementById(`contentCard5Show`).checked = contentCard5Show
    // }, [contentCard1Show, contentCard2Show, contentCard3Show, contentCard4Show, contentCard5Show])



    useEffect(() => {
        const elements = document.querySelectorAll("#sort-content1");
        console.log("🚀 ~ useEffect ~ elements:", elements);

        if (elements.length > 0) {
            const sortableInstance = Sortable.create(elements[0], {
                animation: 150,
                onEnd: (evt) => {
                    console.log('evt.oldIndex:', evt.oldIndex);
                    console.log('evt.newIndex:', evt.newIndex);

                    // อัปเดตลำดับข้อมูลใน cardSeq เมื่อมีการลากแล้วเปลี่ยนตำแหน่ง
                    const updatedCardSeq = [...cardSeq1];
                    const [movedItem] = updatedCardSeq.splice(evt.oldIndex, 1);
                    updatedCardSeq.splice(evt.newIndex, 0, movedItem);
                    setCardSeq1(updatedCardSeq);

                    console.log("Updated cardSeq1:", updatedCardSeq);
                },
            });

            return () => {
                sortableInstance.destroy();
            };
        }

    }, [contentLoading, cardSeq1])

    useEffect(() => {
        const elements = document.querySelectorAll("#sort-content2");
        console.log("🚀 ~ useEffect ~ elements:", elements);

        if (elements.length > 0) {
            const sortableInstance = Sortable.create(elements[0], {
                animation: 150,
                onEnd: (evt) => {
                    console.log('evt.oldIndex:', evt.oldIndex);
                    console.log('evt.newIndex:', evt.newIndex);

                    // อัปเดตลำดับข้อมูลใน cardSeq เมื่อมีการลากแล้วเปลี่ยนตำแหน่ง
                    const updatedCardSeq = [...cardSeq2];
                    const [movedItem] = updatedCardSeq.splice(evt.oldIndex, 1);
                    updatedCardSeq.splice(evt.newIndex, 0, movedItem);
                    setCardSeq2(updatedCardSeq);

                    console.log("Updated cardSeq2:", updatedCardSeq);
                },
            });

            return () => {
                sortableInstance.destroy();
            };
        }

    }, [contentLoading, cardSeq2])

    useEffect(() => {
        const elements = document.querySelectorAll("#sort-content3");
        console.log("🚀 ~ useEffect ~ elements:", elements);

        if (elements.length > 0) {
            const sortableInstance = Sortable.create(elements[0], {
                animation: 150,
                onEnd: (evt) => {
                    console.log('evt.oldIndex:', evt.oldIndex);
                    console.log('evt.newIndex:', evt.newIndex);

                    // อัปเดตลำดับข้อมูลใน cardSeq เมื่อมีการลากแล้วเปลี่ยนตำแหน่ง
                    const updatedCardSeq = [...cardSeq3];
                    const [movedItem] = updatedCardSeq.splice(evt.oldIndex, 1);
                    updatedCardSeq.splice(evt.newIndex, 0, movedItem);
                    setCardSeq3(updatedCardSeq);

                    console.log("Updated cardSeq2:", updatedCardSeq);
                },
            });

            return () => {
                sortableInstance.destroy();
            };
        }

    }, [contentLoading, cardSeq3])

    const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
    document.title = `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

    const itemStyle = {
        padding: '10px',
        border: '1px solid black',
        margin: '5px',
        borderRadius: '8px',
        background: '#f9f9f9',
        transition: 'transform 0.2s ease, background-color 0.3s ease',
    };

    const mapValues = (list = []) => list.map(item => {
        const newObj = {
            attachmentId: item.attachmentId,
            sequence: item.sequence
        }
        return newObj
    })

    if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
        return <Error401 />
    }
    
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={`${PAGE_VIEW} Content Settings`}
                        breadcrumbItems={[
                            { title: "Content Settings", link: "" },
                            { title: PAGE_VIEW },
                        ]}
                    />

                    {/* Render Form */}
                    {
                        contentLoading
                            ? <Spinners setLoading={setContentLoading} />
                            :
                            <Row>
                                <Col className="col-12">
                                    <FormikProvider value={validation}>
                                        <Form
                                            className="form-horizontal"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <Row>
                                                <Col className="col-8">
                                                    <Card>
                                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                            <i className='bx bx-cube-alt'></i> Content Detail
                                                        </h5>
                                                        <CardBody>
                                                            <Row className="">
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Title
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <InputText
                                                                            id="contentDetail"
                                                                            className="form-control"
                                                                            type="text"
                                                                            placeholder="Page Title"
                                                                            name="contentDetail"
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.contentDetail}
                                                                            invalid={validation.touched.contentDetail && validation.errors.contentDetail ? true : false}
                                                                            disabled={pageView === "view"}
                                                                            maxLength={9999}
                                                                        />
                                                                        {
                                                                            validation.touched.contentDetail && validation.errors.contentDetail && (
                                                                                <FormFeedback type="invalid">
                                                                                    {validation.errors.contentDetail}
                                                                                </FormFeedback>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                    <Card>
                                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                            <i className='bx bx-cube-alt'></i> สิ่งแวดล้อม
                                                        </h5>
                                                        <CardBody>
                                                            <Row id="sort-content1">
                                                                {
                                                                    cardSeq1.map((itemNo, index) => {
                                                                        // Access the contentCardXShow state dynamically from the contentCards object
                                                                        const contentCardShow = contentCards[`content1Card${itemNo}Show`];

                                                                        // If the item number is not found or undefined, return an empty fragment
                                                                        if (contentCardShow === undefined) {
                                                                            return <></>;
                                                                        }

                                                                        // Render the CardDetail component with the respective properties
                                                                        return (
                                                                            <CardDetail
                                                                                contentNumber={1}
                                                                                colMd={6}
                                                                                key={itemNo}
                                                                                runningNo={index + 1}
                                                                                pageView={pageView}
                                                                                validation={validation}
                                                                                cardNumber={itemNo}
                                                                                contentCardShow={contentCardShow}
                                                                            />
                                                                        );
                                                                    })
                                                                }
                                                            </Row>

                                                        </CardBody>
                                                    </Card>
                                                    <Card>
                                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                            <i className='bx bx-cube-alt'></i> สังคม
                                                        </h5>
                                                        <CardBody>

                                                            <Row id="sort-content2">
                                                                {
                                                                    cardSeq2.map((itemNo, index) => {
                                                                        // Access the contentCardXShow state dynamically from the contentCards object
                                                                        const contentCardShow = contentCards[`content2Card${itemNo}Show`];

                                                                        // If the item number is not found or undefined, return an empty fragment
                                                                        if (contentCardShow === undefined) {
                                                                            return <></>;
                                                                        }

                                                                        // Render the CardDetail component with the respective properties
                                                                        return (
                                                                            <CardDetail
                                                                                contentNumber={2}
                                                                                colMd={6}
                                                                                key={itemNo}
                                                                                runningNo={index + 1}
                                                                                pageView={pageView}
                                                                                validation={validation}
                                                                                cardNumber={itemNo}
                                                                                contentCardShow={contentCardShow}
                                                                            />
                                                                        );
                                                                    })
                                                                }
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                    <Card>
                                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                            <i className='bx bx-cube-alt'></i> บรรษัทภิบาล และเศรษฐกิจ
                                                        </h5>
                                                        <CardBody>

                                                            <Row id="sort-content1">
                                                                {
                                                                    cardSeq3.map((itemNo, index) => {
                                                                        // Access the contentCardXShow state dynamically from the contentCards object
                                                                        const contentCardShow = contentCards[`content3Card${itemNo}Show`];

                                                                        // If the item number is not found or undefined, return an empty fragment
                                                                        if (contentCardShow === undefined) {
                                                                            return <></>;
                                                                        }

                                                                        // Render the CardDetail component with the respective properties
                                                                        return (
                                                                            <CardDetail
                                                                                contentNumber={3}
                                                                                colMd={6}
                                                                                key={itemNo}
                                                                                runningNo={index + 1}
                                                                                pageView={pageView}
                                                                                validation={validation}
                                                                                cardNumber={itemNo}
                                                                                contentCardShow={contentCardShow}
                                                                            />
                                                                        );
                                                                    })
                                                                }
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>

                                                {/* Tools Box */}
                                                <Col className="col-4">
                                                    <Card outline color="primary" className="border sticky-element">
                                                        <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                                            <i className='bx bx-check'></i> Tools Box
                                                        </h5>
                                                        <CardBody>
                                                            <Row>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Switch Language
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <InputLang widthfull pageView={pageView} forceRoute={false} />
                                                                    </div>
                                                                </Col>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Written at
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <InputGroup>
                                                                            <Flatpickr
                                                                                className="form-control d-block"
                                                                                options={{
                                                                                    dateFormat: 'd/m/Y', // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                                                                }}
                                                                                value={validation.values.contentUpdateDate ? moment(validation.values.contentUpdateDate, 'YYYY-MM-DD').toDate() : null}
                                                                                disabled={true}
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-secondary docs-datepicker-trigger"
                                                                                    disabled
                                                                                >
                                                                                    <i className="fa fa-calendar" aria-hidden="true" />
                                                                                </button>
                                                                            </div>
                                                                        </InputGroup>
                                                                        {
                                                                            (validation.touched.contentUpdateDate && validation.errors.contentUpdateDate) && (
                                                                                <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentUpdateDate}</div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </Col>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Display
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <Select
                                                                            placeholder="Select Status"
                                                                            value={fn_helper.FNFORM.getObjectValue(STATUS_OPTION, `${validation.values.contentStatus}`)}
                                                                            onChange={(value) => validation.setFieldValue("contentStatus", value.id)}
                                                                            getOptionValue={(option) => option.id}
                                                                            getOptionLabel={(option) => option.name}
                                                                            options={STATUS_OPTION}
                                                                            className={`select2-selection ${validation.touched.contentStatus && validation.errors.contentStatus ? "input-err" : ""}`}
                                                                            isDisabled={pageView === "view"}
                                                                        />
                                                                        {
                                                                            (validation.touched.contentStatus && validation.errors.contentStatus) && (
                                                                                <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentStatus}</div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                        <CardFooter>
                                                            <Row>
                                                                {/* <Col className="text-start">
                                                                    <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/business-feature-story/${qLang}`)}>Back</Button>
                                                                </Col> */}
                                                                <Col className="text-end">
                                                                    {pageView !== 'view' && (
                                                                        <Button type="submit" className="btn btn-success">
                                                                            Save  {waitSendData ? <Spinner size="sm" color="light" /> : null}
                                                                        </Button>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </CardFooter>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </FormikProvider>
                                </Col>
                            </Row>
                    }
                </Container>
            </div>
        </React.Fragment>
    )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(SustainabilityPerformanceContentTemplate)
